// gender
export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
  UNKNOWN = 'unknown',
}

export enum GENDER_UK {
  MALE = 'Male',
  FEMALE = 'Female',
  OTHER = 'Other',
}

export const genderOptions = Object.values(GENDER)
export type Gender = (typeof genderOptions)[number]
export const genderMap = {
  [GENDER.MALE]: 'Male',
  [GENDER.FEMALE]: 'Female',
  [GENDER.UNKNOWN]: 'Unknown',
}
